import {
  DEFAULT_IMAGE_URL,
  IMAGE_DOMAIN_BASE_URL,
  IMAGE_DOMAIN_NOVASOL,
  IMAGE_WIDTH_AWAZE,
  IMAGE_WIDTH_NOVASOL,
} from '@/constants'

export type NovasolAssetId = `${string}/${string}`

export const isNovasolAssetId = (assetId: string): assetId is NovasolAssetId =>
  /^[^/]+\/[^/]+$/.test(assetId)

export const formatNovasolImageUrl = (
  assetId: string,
  width: number,
  domain = IMAGE_DOMAIN_NOVASOL,
): string => {
  if (!isNovasolAssetId(assetId)) return DEFAULT_IMAGE_URL

  const separatorIndex = assetId.indexOf('/')
  const propertySuffix = assetId.slice(separatorIndex + 1)

  return `${domain}/pic/${width}/${propertySuffix.substring(0, 3)}/${propertySuffix}`
}

export const formatAwazeImageUrl = (
  assetId: string,
  width: number,
  domain = IMAGE_DOMAIN_BASE_URL,
): string => `${domain}/${assetId.substring(0, 3)}/${width}/${assetId}.jpg`

interface FormatPropertyImageUrlOptions {
  awazeDomain?: string
  awazeWidth?: number
  novasolDomain?: string
  novasolWidth?: number
}

export const formatPropertyImageUrl = (
  assetId: string,
  {
    awazeDomain = IMAGE_DOMAIN_BASE_URL,
    awazeWidth = IMAGE_WIDTH_AWAZE,
    novasolDomain = IMAGE_DOMAIN_NOVASOL,
    novasolWidth = IMAGE_WIDTH_NOVASOL,
  }: FormatPropertyImageUrlOptions = {},
): string => {
  if (!assetId) return DEFAULT_IMAGE_URL

  if (isNovasolAssetId(assetId)) {
    return formatNovasolImageUrl(assetId, novasolWidth, novasolDomain)
  }

  // A raw Awaze asset ID contains no path separators. Reject malformed IDs
  // and URLs rather than accidentally constructing a broken CDN URL.
  if (assetId.includes('/')) return DEFAULT_IMAGE_URL

  return formatAwazeImageUrl(assetId, awazeWidth, awazeDomain)
}
